import { createSelector } from 'reselect';

import { ReferralCodeStore } from './typings';

const storeSelector = <T extends { referralCode: ReferralCodeStore }>(storeState: T): ReferralCodeStore =>
    storeState.referralCode;

export const getReferralCode = createSelector(storeSelector, (store) => store.referralCode);

export const getReferralCodeLoadingStatus = createSelector(storeSelector, (store) => store.loadingStatus);
